var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4065_7863)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10573 0.853713C6.35099 0.717706 6.64901 0.717709 6.89427 0.853713L12.5824 4.01008C12.8401 4.15319 12.9998 4.42493 13 4.71952V8.48498C13 11.4328 11.4005 14.1495 8.82115 15.5811L6.89427 16.6497C6.64897 16.7857 6.35103 16.7857 6.10573 16.6497L4.17885 15.5811C1.59949 14.1495 0 11.4328 0 8.48498V4.71952C0.00015115 4.42493 0.15986 4.15319 0.417621 4.01008L6.10573 0.853713ZM9.77357 6.69731C9.53567 6.45964 9.14989 6.45979 8.91189 6.69731L6.09251 9.51305L4.89868 8.32127C4.6607 8.08353 4.27498 8.08353 4.037 8.32127C3.79903 8.55901 3.79903 8.94436 4.037 9.1821L5.66167 10.8052C5.89965 11.0429 6.28537 11.0429 6.52335 10.8052L9.77357 7.55814C10.0113 7.32038 10.0115 6.93498 9.77357 6.69731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4065_7863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    fill: "white",
    transform: "translate(0 0.751709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.57208c01d457192fdceaf5e9348eca0e.svg";
export { ForwardRef as ReactComponent };